import _extends from '@babel/runtime/helpers/esm/extends';
import _classCallCheck from '@babel/runtime/helpers/esm/classCallCheck';
import _createClass from '@babel/runtime/helpers/esm/createClass';
import _assertThisInitialized from '@babel/runtime/helpers/esm/assertThisInitialized';
import _inherits from '@babel/runtime/helpers/esm/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/esm/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/esm/getPrototypeOf';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import React, { Component } from 'react';
import { calculateDrag, isValidDrag, cleanDrag, dragStartingPoints } from './toggleHelper.js';
import DSToggleRender from './DSToggleRender.js';
import { togglePropTypes } from './props.js';
import '@elliemae/ds-utilities/onClickHandlerForNonInteractiveElements';
import '@elliemae/ds-classnames';
import '@elliemae/ds-tooltip';
import 'prop-types';
import '../prop-types-cc01d273.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DSToggleImpl = /*#__PURE__*/function (_Component) {
  _inherits(DSToggleImpl, _Component);

  var _super = _createSuper(DSToggleImpl);

  function DSToggleImpl(props) {
    var _this;

    _classCallCheck(this, DSToggleImpl);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onDragStart", function (clientX) {
      var _this$state = _this.state,
          startPoint = _this$state.startPoint,
          checked = _this$state.checked,
          isDragging = _this$state.isDragging,
          boxWidth = _this$state.boxWidth,
          circleWidth = _this$state.circleWidth; // const { checked: checkedProp, } = this.props

      var drag = calculateDrag(clientX, {
        startPoint: startPoint,
        checked: checked,
        isDragging: isDragging,
        boxWidth: boxWidth,
        circleWidth: circleWidth
      });
      if (drag) _this.setState({
        drag: drag
      }); // else this.setDragOnChange(checkedProp != null ? checkedProp : checked) // set initial position
      else _this.setDragOnChange(checked); // set initial position
    });

    _defineProperty(_assertThisInitialized(_this), "onDragStop", function (e) {
      var checked = _this.state.checked; // const { checked: checkedProp, } = this.props

      if (isValidDrag(_this.state)) {
        _this.onChange(e);

        _this.setState(cleanDrag); // } else this.setDragOnChange(checkedProp != null ? checkedProp : checked) // set initial position

      } else _this.setDragOnChange(checked); // set initial position

    });

    _defineProperty(_assertThisInitialized(_this), "onBlur", function (e) {
      var _this$props = _this.props,
          onBlur = _this$props.onBlur,
          id = _this$props.id;
      if (onBlur) onBlur(e, id);
    });

    _defineProperty(_assertThisInitialized(_this), "onFocus", function (e) {
      var _this$props2 = _this.props,
          onFocus = _this$props2.onFocus,
          id = _this$props2.id;
      if (onFocus) onFocus(e, id);
    });

    _defineProperty(_assertThisInitialized(_this), "onChange", function (e) {
      var checked = _this.state.checked;
      var _this$props3 = _this.props,
          onChange = _this$props3.onChange,
          id = _this$props3.id,
          value = _this$props3.value;
      var newCheck = !checked; // this.setState({
      //   checked: checkedProp != null ? checkedProp : newCheck,
      // })

      _this.setState({
        checked: newCheck
      });

      e.target.value = value;
      e.target.checked = newCheck;
      e.checked = newCheck;
      onChange(e, id); // this.setDragOnChange(checkedProp != null ? checkedProp : newCheck) // set new position

      _this.setDragOnChange(newCheck); // set new position

    });

    _defineProperty(_assertThisInitialized(_this), "onMouseEnter", function () {
      _this.setState({
        inside: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseLeave", function () {
      _this.setState({
        inside: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseMove", function (event) {
      event.preventDefault();

      _this.onDragStart(event.clientX);
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseDown", function (event) {
      _this.onDragStart(event.clientX);

      _this.setState({
        startPoint: event.clientX,
        isDragging: true
      });

      window.addEventListener('mousemove', _this.onMouseMove);
      window.addEventListener('mouseup', _this.onMouseUp);
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseUp", function (event) {
      _this.onDragStop(event);

      window.removeEventListener('mousemove', _this.onMouseMove);
      window.removeEventListener('mouseup', _this.onMouseUp);
    });

    _defineProperty(_assertThisInitialized(_this), "onTouchCancel", function () {
      _this.setState({
        inside: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onTouchEnd", function (event) {
      event.preventDefault();

      _this.onDragStop(event);
    });

    _defineProperty(_assertThisInitialized(_this), "onTouchMove", function (event) {
      _this.onDragStart(event.touches[0].clientX);
    });

    _defineProperty(_assertThisInitialized(_this), "onTouchStart", function (event) {
      _this.onDragStart(event.touches[0].clientX);

      _this.setState({
        startPoint: event.touches[0].clientX,
        isDragging: true
      });
    });

    _this.state = {
      checked: props.checked || false,
      inside: false,
      isDragging: false,
      // prevent draw of toggle before drag handle positioning calculations
      hide: true,
      drag: null,
      startPoint: null,
      circleWidth: null,
      boxWidth: null
    };
    _this.circle = /*#__PURE__*/React.createRef();
    _this.box = /*#__PURE__*/React.createRef();
    return _this;
  }

  _createClass(DSToggleImpl, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.verifyElements();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (this.state.hide && this.state.circleWidth && this.state.boxWidth && prevState.hide && this.state.drag !== null) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          hide: false
        });
      }

      if (snapshot) {
        this.verifyElements();
      }
    }
    /**
     * ******************************************************
     * Drag
     * ****************************************************** *
     *
     * @param clientX
     */

  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps) {
      var size = this.props.size;

      if (prevProps.size !== size) {
        return true;
      }

      return false;
    }
    /**
     * ******************************************************
     * other
     * ****************************************************** *
     *
     * @param currentCheckState
     */

  }, {
    key: "setDragOnChange",
    value: function setDragOnChange(currentCheckState) {
      this.setState(dragStartingPoints(currentCheckState));
    }
  }, {
    key: "verifyElements",
    value: function verifyElements() {
      var _this2 = this;

      var checked = this.state.checked;
      var checkedProp = this.props.checked;
      var nodesInterval = setInterval(function () {
        // !important it checks when nodes are availables
        if (!_this2.circle || !_this2.box || !_this2.circle.current || !_this2.box.current) return;
        var circleWidth = _this2.circle.current.clientWidth;
        var boxWidth = _this2.box.current.clientWidth;
        if (!circleWidth || !boxWidth || circleWidth === boxWidth) return;

        _this2.setState({
          boxWidth: boxWidth,
          circleWidth: circleWidth
        });

        _this2.setDragOnChange(checkedProp != null ? checkedProp : checked); // this.setDragOnChange(checked)


        clearInterval(nodesInterval);
      }, 5);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state2 = this.state,
          checked = _this$state2.checked,
          drag = _this$state2.drag,
          inside = _this$state2.inside,
          hide = _this$state2.hide;
      var dragStyle = drag !== null || checked || this.props.checked ? {
        left: "".concat(drag, "px")
      } : null;
      return /*#__PURE__*/React.createElement(DSToggleRender, _extends({}, this.props, {
        defaultState: this.props.checked,
        checked: checked,
        containerRef: this.box,
        hide: hide,
        dragStyle: dragStyle,
        handRef: this.circle,
        inside: inside,
        onBlur: this.onBlur,
        onChange: this.onChange,
        onFocus: this.onFocus,
        onMouseDown: this.onMouseDown,
        onMouseEnter: this.onMouseEnter,
        onMouseLeave: this.onMouseLeave,
        onTouchCancel: this.onTouchCancel,
        onTouchEnd: this.onTouchEnd,
        onTouchMove: this.onTouchMove,
        onTouchStart: this.onTouchStart
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if (props.checked === true || props.checked === false) {
        return _objectSpread({
          checked: props.checked
        }, dragStartingPoints(props.checked)(state));
      }

      return null;
    }
  }]);

  return DSToggleImpl;
}(Component);

DSToggleImpl.propTypes = togglePropTypes;

export default DSToggleImpl;
//# sourceMappingURL=DSToggleImpl.js.map
